function NewDynamicDemo() {
    return {
        id: null,       
        dynamicDemoQuestion: {
            questionId: null,
            demoQuestionCode: "",
            demoQuestionText: ""
        },
        comparisonType: null,
		numberOfDays: null,
        numberOfTimes: null,
        dynamicDemographicParams: []
      }
}
export default NewDynamicDemo;